import { useState } from "react";

const BankSelectScreen = ({ banks = [], onSelect, setSelectedBank }) => {
  const [query, setQuery] = useState("");

  const filteredBanks = banks.filter((bank) =>
    bank?.name?.toLowerCase().includes(query.toLowerCase())
  );

  const handleSelectBank = (bank) => {
    setSelectedBank(bank.code);
    onSelect(bank);     // Store selected bank in parent
    // onNext();           // Immediately move to next step
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 flex justify-center">
      <div className="bg-white shadow-lg rounded-2xl p-6 w-full border border-gray-100">

        <h2 className="text-lg sm:text-xl font-semibold text-[#003399] mb-4">
          Select Bank
        </h2>

        {/* Search bar */}
        <input
          type="text"
          placeholder="Search bank..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-[#6699FF] mb-4"
        />

        {/* Bank list */}
        <div className="max-h-80 overflow-y-auto pr-1 space-y-2">
          {filteredBanks.length > 0 ? (
            filteredBanks.map((bank) => (
              <div
                key={bank.code}
                onClick={() => handleSelectBank(bank)}
                className="p-3 border rounded-lg bg-gray-50 hover:bg-[#6699FF]/10 cursor-pointer flex justify-between"
              >
                <span className="text-sm font-medium text-gray-800">{bank.name}</span>
                <span className="text-xs text-gray-500">{bank.code}</span>
              </div>
            ))
          ) : (
            <p className="text-center text-gray-400 text-sm py-4">No banks match your search.</p>
          )}
        </div>

      </div>
    </div>
  );
};

export default BankSelectScreen;
